import { ContactDto, MailFileDto } from 'src/app/shared/interfaces';
import { NatureCustomFieldDto } from '../../interfaces/natures';
import { WorkflowInstance } from '../workflows/workflow-instance';
import { DigitalCentersVMDTO } from 'src/app/shared/interfaces/digital-centers/digital-centers-vm-dto.interface';

export class MailDetails {
  id: number;
  serviceProprietaireId: number;
  refExpediteur: string;
  dateEncodage: Date | string;
  dateEntree: Date | string;
  dateDocument: Date | string;
  dateEcheance: Date | string;
  natureId: number;
  supprime: boolean;
  version: number;
  centreNumerisationId: number;
  pinned: boolean;
  referenceRecommande: string;
  expediteurIdiAdmin: number;
  expediteurId: number;
  expediteurLibre: string;
  sourceId: number;
  classementId: number;
  classeurId: number;
  chemiseId: number;
  remarques: string;
  confidentiel: boolean;
  objet: string;
  typeEntrantSortant: string;
  datePostale: Date;
  boiteArchive: string;
  statutId: number;
  mauvaisRoutage: boolean;
  mauvaisRoutageCommentaires: string;
  avalider: boolean;
  validationEtape: number;
  aCompleter: boolean;
  writeLockId: string;
  bacId: number;
  workflowId: string;

  annexeNonScannee: boolean;
  annexeNonScanneeNombre: number;
  annexeDiffusee: boolean;
  writeLock?: MailDetailsLockedWriteDto;
  nature: MailDetailsNatureDto;
  centreNumerisation: DigitalCentersVMDTO;
  validationEtapeMax: number;
  validationEtapeUserIds: number[];
  serviceProprietaire: MailDetailsMainServiceDto;
  classement: MailDetailsClassificationDto;
  classeur: MailDetailsFolderDto;
  chemise: MailDetailsBinderDto;
  priseEnChargeInfo?: MailDetailsTakeOverDto;
  natureCustomDatas: MailDetailsCustomNatureDataDto[];
  validationUsers?: string;
  filesToValidate?: MailFileDto[];
  filesToSign?: MailFileDto[];
  statusGlobalBackground?: string | null;
  statusGlobalName?: string | null;
  statusGlobalColor?: string | null;
  bacLabelForInfos?: string;
  workflowForInfos?: WorkflowInstance;
  workflowForInfosArray?: WorkflowInstance[];
  workflowStartDefinitionId?: string;
  centreNumLabel?: string;
  source?: string; // added for display
  expediteurFull?: ContactDto; // added for display

  constructor(data?) {
    Object.assign(this, data);
  }
}

export interface MailDetailsLockedWriteDto {
  id: number;
  mailId: number;
  contactId: number;
  contact?;
  source: string;
  version: number;
  date: Date;
}

export interface MailDetailsNatureDto {
  description: string;
  id: number;
  natureCustomFields?: NatureCustomFieldDto[]; // mandatory because when you get the mail.nature, it doesn't have it. We add it when we need to display the mail in CourrierDetailsGeneralInfosComponent
  privee: number;
  servicesAutorises: string;
  servicesAutorisesList: number[];
}

export interface MailDetailsMainServiceDto {
  id: number;
  description: string;
  parentId: number;
  codeService: string;
}

export interface MailDetailsClassificationDto {
  id: number;
  description: string;
  code: string;
  actif: boolean;
}

export interface MailDetailsFolderDto {
  id: number;
  description: string;
  classementId: string;
  archived: boolean;
}
export type MailDetailsBinderDto = MailDetailsFolderDto;

export interface MailDetailsTakeOverDto {
  serviceId: number;
  dateDemande: Date;
  datePremierePriseEnCharge: Date;
  dateDernierePriseEnCharge: Date;
  dateMax: Date;
  auNomDeServiceId: number;
  commentaire: string;
  statutDemande: string;
  demandeurContactId: number;
  serviceLabel?: string; // added for display
  demandeurContactLabel?: string; // added for display
}

export interface MailDetailsCustomNatureDataDto {
  id: number;
  natureCustomFieldId: number;
  name: string;
  description: string;
  type: string;
  utilisable: boolean;
  textValue: string;
  numberValue: number;
  decimalValue: number;
  dateValue: string;
  saved: boolean;
  dropdownValue?: string;
  listValueItemId?: number;
}
